function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 2V7",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.55556 2V7",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.75,
  y: 4.97223,
  width: 18.5,
  height: 16.2778,
  rx: 1.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9.77778,
  r: 0.611111,
  stroke: "#627080"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.4444,
  cy: 9.77778,
  r: 0.611111,
  stroke: "#627080"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 13.6667,
  r: 0.611111,
  stroke: "#627080"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.55555,
  cy: 13.6667,
  r: 0.611111,
  stroke: "#627080"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.4444,
  cy: 13.6667,
  r: 0.611111,
  stroke: "#627080"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 17.5556,
  r: 0.611111,
  stroke: "#627080"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.55555,
  cy: 17.5556,
  r: 0.611111,
  stroke: "#627080"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.4444,
  cy: 17.5556,
  r: 0.611111,
  stroke: "#627080"
});

const SvgCalendar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Calendar.9ede128d.svg";
export { ForwardRef as ReactComponent };